function getUnbxdAnalyticsConfig() {
    return window.UnbxdAnalyticsConfig || {};
  }
  var UnbxdSiteName = getUnbxdAnalyticsConfig().siteKey || '';
  var UnbxdApiKey = getUnbxdAnalyticsConfig().apiKey || '';
  function u_decodeAndParse(s) {
    if (s.indexOf('"') === 0) {
      s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
    }
    return u_decodeCookie(s);
  }
  function u_decodeCookie(s) {
    var pluses = /\+/g;
    return decodeURIComponent(s.replace(pluses, ' '));
  }
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  function readCookie(key) {
    var cookies = document.cookie.split('; ');
    var result;
    for (var i = 0, l = cookies.length; i < l; i++) {
      var parts = cookies[i].split('=');
      var name = u_decodeCookie(parts.shift());
      var cookie = parts.join('=');
      if (key && key === name) {
        try {
          result = u_decodeAndParse(cookie);
          break;
        } catch (e) {}
      }
    }
    return result;
  }
  function ensureUnbxdUserId() {
    var uid = readCookie('unbxd.userId');
    if (!uid) {
      uid = 'uid-' + Date.now() + '-' + Math.floor(Math.random() * 100000);
      setCookie('unbxd.userId', '"' + uid + '"', 365);
    }
    return uid;
  }
  window.getUnbxdUserId = ensureUnbxdUserId;
  ensureUnbxdUserId();
    window.UnbxdWidgetsConf = window.UnbxdWidgetsConf || {}; 
  UnbxdWidgetsConf['uid'] = readCookie('unbxd.userId');

  window.renderUnbxdKlaviyoReviews = function () {
    function hydrate() {
      try {
        if (window.klReviewsObject && typeof window.klReviewsObject.renderWidgets === 'function') {
          window.klReviewsObject.renderWidgets();
        }
      } catch (err) {}
      if (typeof window.update_review === 'function') {
        window.update_review();
      }
    }

    hydrate();
    setTimeout(hydrate, 200);
    setTimeout(hydrate, 600);
    setTimeout(hydrate, 1200);
  };

  window.patchUnbxdAddPageView = function () {
    if (!window.Unbxd || typeof window.Unbxd.addPageView !== 'function') return false;
    if (window.Unbxd.__addPageViewPatched) return true;
    window.Unbxd.__addPageViewPatched = true;

    var originalAddPageView = window.Unbxd.addPageView.bind(window.Unbxd);
    window.Unbxd.addPageView = function (config, misc, meta) {
      if (config == null || typeof config !== 'object') config = {};
      if (misc == null || typeof misc !== 'object') misc = {};

      var query = '';
      if (config.misc && config.misc.query) {
        query = String(config.misc.query);
      } else if (misc.query) {
        query = String(misc.query);
      } else if (window.getUnbxdSearchQueryFromUrl) {
        query = window.getUnbxdSearchQueryFromUrl();
      }

      var signature = [
        config.pageType || '',
        config.url || window.location.pathname + window.location.search,
        query.trim().toLowerCase()
      ].join('|');

      if (window.__unbxdPageViewSignature === signature) {
        return;
      }
      window.__unbxdPageViewSignature = signature;

      return originalAddPageView(config, misc, meta);
    };
    return true;
  };

  window.whenUnbxdTrackReady = function (callback, attempts) {
    attempts = attempts || 0;
    if (
      window.Unbxd
      && (typeof window.Unbxd.push === 'function' || typeof window.Unbxd.track === 'function')
    ) {
      if (window.patchUnbxdAddPageView) window.patchUnbxdAddPageView();
      if (window.patchUnbxdAutosuggestSearchDedup) window.patchUnbxdAutosuggestSearchDedup();
      if (window.patchUnbxdPlainSearchPushDedup) window.patchUnbxdPlainSearchPushDedup();
      callback();
      return;
    }
    if (attempts >= 80) return;
    setTimeout(function () {
      window.whenUnbxdTrackReady(callback, attempts + 1);
    }, 100);
  };

  window.shouldSkipUnbxdSearchTrack = function (query, autosuggestData) {
    var dedupeKey = autosuggestData && autosuggestData.autosuggest_type
      ? [
          'autosuggest',
          String(query || '').toLowerCase(),
          String(autosuggestData.internal_query || '').toLowerCase(),
          autosuggestData.autosuggest_type
        ].join('|')
      : ['search', String(query || '').toLowerCase()].join('|');
    var now = Date.now();
    window.__unbxdSearchTrackDedup = window.__unbxdSearchTrackDedup || {};
    var lastAt = window.__unbxdSearchTrackDedup[dedupeKey];
    if (lastAt && (now - lastAt) < 2500) return true;
    window.__unbxdSearchTrackDedup[dedupeKey] = now;
    return false;
  };

  window.patchUnbxdAutosuggestSearchDedup = function () {
    if (!window.Unbxd || typeof window.Unbxd.addSearch !== 'function') return false;
    if (window.Unbxd.__autosuggestSearchDedupPatched) return true;
    window.Unbxd.__autosuggestSearchDedupPatched = true;

    var originalAddSearch = window.Unbxd.addSearch.bind(window.Unbxd);
    window.Unbxd.addSearch = function (query, autosuggestData, misc, meta) {
      if (
        !autosuggestData
        && window.shouldSuppressVanillaSearchTrackForAutosuggest
        && window.shouldSuppressVanillaSearchTrackForAutosuggest(query)
      ) {
        return;
      }
      if (window.shouldSkipUnbxdSearchTrack(query, autosuggestData)) return;
      return originalAddSearch(query, autosuggestData, misc, meta);
    };
    return true;
  };

  window.patchUnbxdPlainSearchPushDedup = function () {
    if (!window.Unbxd || typeof window.Unbxd.push !== 'function') return false;
    if (window.Unbxd.__plainSearchPushDedupPatched) return true;
    window.Unbxd.__plainSearchPushDedupPatched = true;

    var originalPush = window.Unbxd.push.bind(window.Unbxd);
    window.Unbxd.push = function (action, payload, meta) {
      if (action === 'search' && payload) {
        if (window.isUnbxdAutosuggestSearchClickActive && window.isUnbxdAutosuggestSearchClickActive()) {
          return;
        }
        var query = payload.query || '';
        if (window.shouldSkipUnbxdSearchTrack(query, null)) return;
      }
      return originalPush.apply(window.Unbxd, arguments);
    };
    return true;
  };

  window.patchUnbxdAutosuggestInternalQueryConfig = function () {
    if (!window.UnxAnalyticsConfig || !Array.isArray(window.UnxAnalyticsConfig.autosuggest)) return;
    window.UnxAnalyticsConfig.autosuggest.forEach(function (cfg) {
      if (!cfg || !cfg.internalQuery) return;
      cfg.internalQuery.selector = '#Search-In-Modal, #Search-In-Modal-mobile';
    });
  };

  (function patchUnbxdAddPageViewOnce() {
    function waitForUnbxdAnalyticsPatches(attempts) {
      attempts = attempts || 0;
      var pageViewReady = window.patchUnbxdAddPageView && window.patchUnbxdAddPageView();
      var searchDedupReady = window.patchUnbxdAutosuggestSearchDedup && window.patchUnbxdAutosuggestSearchDedup();
      var plainSearchDedupReady = window.patchUnbxdPlainSearchPushDedup && window.patchUnbxdPlainSearchPushDedup();
      if (pageViewReady && searchDedupReady && plainSearchDedupReady) return;
      if (attempts >= 150) return;
      setTimeout(function () {
        waitForUnbxdAnalyticsPatches(attempts + 1);
      }, 100);
    }

    waitForUnbxdAnalyticsPatches(0);
    window.addEventListener('load', function () {
      if (window.patchUnbxdAutosuggestInternalQueryConfig) {
        window.patchUnbxdAutosuggestInternalQueryConfig();
      }
      waitForUnbxdAnalyticsPatches(0);
    });
  })();

  window.getUnbxdSearchQueryFromUrl = function () {
    try {
      var params = new URLSearchParams(window.location.search);
      var q = params.get('query') || params.get('q') || '';
      if (!q) return '';
      return decodeURIComponent(String(q).replace(/\+/g, ' ')).trim();
    } catch (err) {
      return '';
    }
  };

  window.resetUnbxdSearchAnalyticsSignatures = function () {
    window.__unbxdPageViewSignature = '';
    window.__unbxdLastSearchQueryTrackSignature = '';
    if (window.unbxdSearch) {
      window.unbxdSearch.__unbxdLastImpressionSignature = '';
    }
  };

  window.patchUnbxdSearchPageViewConfig = function () {
    if (!window.UnxAnalyticsConfig || !window.UnxAnalyticsConfig.pageView) return;
    window.UnxAnalyticsConfig.pageView.events = window.UnxAnalyticsConfig.pageView.events || {};
    var searchPageViewEvent = window.UnxAnalyticsConfig.pageView.events.search || {};
    window.UnxAnalyticsConfig.pageView.events.search = Object.assign({}, searchPageViewEvent, {
      urlIdentifiers: { urls: ['/search'], exactMatch: false },
      uniqueSelectors: {
        selectors: [
          '#searchResultsWrapper',
          '.UNX-results-container',
          '.UNX-product-list .product-item'
        ],
        operation: 'or'
      },
      misc: Object.assign({}, searchPageViewEvent.misc || {}, {
        fireSearch: function () {
          return '';
        }
      })
    });
  };

  window.clearUnbxdAutosuggestRedirectSearchState = function () {
    try {
      sessionStorage.removeItem('unbxdAutosuggestClickAt');
      sessionStorage.removeItem('unbxdAutosuggestSuggestionQuery');
      sessionStorage.removeItem('unbxdAutosuggestInternalQuery');
      sessionStorage.removeItem('unbxdAutosuggestDoctype');
      sessionStorage.removeItem('unbxdAutosuggestClickSignature');
      sessionStorage.removeItem('unbxdAutosuggestSearchFired');
    } catch (err) {}
  };

  window.isUnbxdAutosuggestSearchClickActive = function () {
    try {
      var clickAt = parseInt(sessionStorage.getItem('unbxdAutosuggestClickAt') || '0', 10);
      var suggestionQuery = sessionStorage.getItem('unbxdAutosuggestSuggestionQuery') || '';
      if (!clickAt || !suggestionQuery) return false;
      return (Date.now() - clickAt) <= 15000;
    } catch (err) {
      return false;
    }
  };

  window.shouldSuppressVanillaSearchTrackForAutosuggest = function (query) {
    if (!window.isUnbxdAutosuggestSearchClickActive()) return false;

    try {
      var suggestionQuery = sessionStorage.getItem('unbxdAutosuggestSuggestionQuery') || '';
      if (!suggestionQuery) return false;
      return String(query || '').trim().toLowerCase() === suggestionQuery.trim().toLowerCase();
    } catch (err) {
      return false;
    }
  };

  window.shouldSkipSearchQueryTrackForAutosuggest = function (query) {
    try {
      if (!window.isUnbxdAutosuggestSearchClickActive()) return false;

      var suggestionQuery = sessionStorage.getItem('unbxdAutosuggestSuggestionQuery') || '';
      var alreadyFired = sessionStorage.getItem('unbxdAutosuggestSearchFired') === '1';
      var normalizedQuery = String(query || '').trim().toLowerCase();
      var normalizedSuggestion = suggestionQuery.trim().toLowerCase();

      if (alreadyFired) {
        window.clearUnbxdAutosuggestRedirectSearchState();
        return true;
      }

      if (normalizedQuery !== normalizedSuggestion) {
        return true;
      }

      return false;
    } catch (err) {
      return false;
    }
  };

  window.consumeAutosuggestRedirectSearch = function (query) {
    try {
      var clickAt = parseInt(sessionStorage.getItem('unbxdAutosuggestClickAt') || '0', 10);
      var suggestionQuery = sessionStorage.getItem('unbxdAutosuggestSuggestionQuery') || '';
      var internalQuery = sessionStorage.getItem('unbxdAutosuggestInternalQuery') || '';
      var doctype = sessionStorage.getItem('unbxdAutosuggestDoctype') || 'KEYWORD_SUGGESTION';

      if (!clickAt || !suggestionQuery) return null;
      if ((Date.now() - clickAt) > 15000) return null;
      if (String(query || '').trim().toLowerCase() !== suggestionQuery.trim().toLowerCase()) return null;

      window.clearUnbxdAutosuggestRedirectSearchState();

      return {
        query: suggestionQuery,
        autosuggestData: {
          autosuggest_type: doctype,
          autosuggest_suggestion: suggestionQuery,
          internal_query: internalQuery
        }
      };
    } catch (err) {
      return null;
    }
  };

  window.fireUnbxdSearchQueryTrack = function (instance) {
    var query = '';

    if (instance && instance.state && instance.state.userInput) {
      query = String(instance.state.userInput).trim();
    }
    if (!query) {
      query = window.getUnbxdSearchQueryFromUrl();
    }
    if (!query && window.getUnbxdSearchQueryFromInstance) {
      query = window.getUnbxdSearchQueryFromInstance(instance);
    }
    if (!query && window.UnbxdAnalyticsConf && window.UnbxdAnalyticsConf.query) {
      query = String(window.UnbxdAnalyticsConf.query).trim();
    }
    if (!query) return false;

    var signature = window.location.pathname + window.location.search + '|' + query.toLowerCase();
    if (window.__unbxdLastSearchQueryTrackSignature === signature) return true;
    if (
      !window.Unbxd
      || (typeof window.Unbxd.push !== 'function' && typeof window.Unbxd.addSearch !== 'function')
    ) {
      return false;
    }

    if (window.shouldSkipSearchQueryTrackForAutosuggest && window.shouldSkipSearchQueryTrackForAutosuggest(query)) {
      window.__unbxdLastSearchQueryTrackSignature = signature;
      return true;
    }

    var autosuggestPayload = window.consumeAutosuggestRedirectSearch
      ? window.consumeAutosuggestRedirectSearch(query)
      : null;

    window.__unbxdLastSearchQueryTrackSignature = signature;
    window.UnbxdAnalyticsConf = window.UnbxdAnalyticsConf || {};
    window.UnbxdAnalyticsConf.query = query;

    try {
      if (window.sessionStorage) {
        window.sessionStorage.removeItem('prevSearchQuery');
      }
    } catch (err) {}

    if (autosuggestPayload && typeof window.Unbxd.addSearch === 'function') {
      window.Unbxd.addSearch(autosuggestPayload.query, autosuggestPayload.autosuggestData);
      return true;
    }

    if (typeof window.Unbxd.push === 'function') {
      window.Unbxd.push('search', { query: query });
    }

    return true;
  };

  window.trackUnbxdSearchPageAnalytics = function (instance) {
    if (!instance || instance.options.productType !== 'SEARCH') return;

    window.whenUnbxdTrackReady(function () {
      window.fireUnbxdSearchQueryTrack(instance);
    });
  };

  (function patchUnbxdProductImpressionOnce() {
    var lastSignature = '';
    var lastUrl = window.location.href;
    var lastSearch = window.location.search;
    var debounceTimer = null;
    var DEBOUNCE_MS = 750;

    function resetImpressionSignatureIfUrlChanged() {
      var currentUrl = window.location.href;
      var currentSearch = window.location.search;
      if (currentUrl !== lastUrl || currentSearch !== lastSearch) {
        lastUrl = currentUrl;
        lastSearch = currentSearch;
        lastSignature = '';
        if (window.resetUnbxdFacetsSignature) window.resetUnbxdFacetsSignature();
        if (window.resetUnbxdSearchAnalyticsSignatures) window.resetUnbxdSearchAnalyticsSignatures();
      }
    }

    function buildImpressionSignature(payload) {
      if (!payload || !payload.pids_list || !payload.pids_list.length) return '';
      var pidsKey = (Array.isArray(payload.pids_list) ? payload.pids_list : [payload.pids_list])
        .map(function (id) { return String(id); })
        .sort()
        .join(',');
      if (payload.page) {
        return ['browse', payload.page, payload.page_type || '', pidsKey].join('|');
      }
      if (payload.query) {
        return ['search', String(payload.query), pidsKey].join('|');
      }
      return ['other', pidsKey].join('|');
    }

    function cloneImpressionPayload(payload) {
      return {
        pids_list: (Array.isArray(payload.pids_list) ? payload.pids_list : [payload.pids_list]).slice(),
        page: payload.page,
        page_type: payload.page_type,
        query: payload.query,
        requestId: payload.requestId
      };
    }

    function installPatch() {
      if (!window.Unbxd || typeof window.Unbxd.addProductsImpression !== 'function') return false;
      if (window.Unbxd.__impressionOncePatched) return true;
      window.Unbxd.__impressionOncePatched = true;

      var original = window.Unbxd.addProductsImpression.bind(window.Unbxd);
      window.Unbxd.addProductsImpression = function (payload, meta) {
        if (!payload || !payload.pids_list || !payload.pids_list.length) {
          return original(payload, meta);
        }

        resetImpressionSignatureIfUrlChanged();
        var signature = buildImpressionSignature(payload);
        if (!signature || signature === lastSignature) return;

        lastSignature = signature;

        var snapshot = {
          payload: cloneImpressionPayload(payload),
          meta: meta
        };

        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          original(snapshot.payload, snapshot.meta);
        }, DEBOUNCE_MS);
      };
      return true;
    }

    function waitForUnbxd(attempts) {
      attempts = attempts || 0;
      if (installPatch()) return;
      if (attempts >= 100) return;
      setTimeout(function () { waitForUnbxd(attempts + 1); }, 100);
    }

    waitForUnbxd(0);
    window.addEventListener('popstate', resetImpressionSignatureIfUrlChanged);

    if (window.history && typeof window.history.pushState === 'function') {
      var originalPushState = window.history.pushState.bind(window.history);
      window.history.pushState = function (state, title, url) {
        if (arguments.length >= 3 && (url === -1 || url == null || String(url) === '-1')) {
          return;
        }
        var result = originalPushState.apply(window.history, arguments);
        resetImpressionSignatureIfUrlChanged();
        return result;
      };
    }

    if (window.history && typeof window.history.replaceState === 'function' && !window.__unbxdReplaceStateGuard) {
      window.__unbxdReplaceStateGuard = true;
      var originalReplaceState = window.history.replaceState.bind(window.history);
      window.history.replaceState = function (state, title, url) {
        if (arguments.length >= 3 && (url === -1 || url == null || String(url) === '-1')) {
          return;
        }
        return originalReplaceState.apply(window.history, arguments);
      };
    }
  })();

  (function patchUnbxdProductClickOnce() {
    var lastClickKey = '';
    var lastClickAt = 0;
    var CLICK_DEDUPE_MS = 1500;

    function buildClickKey(pid, rank) {
      return String(pid || '') + '|' + String(rank != null ? rank : '');
    }

    function shouldSkipDuplicateClick(pid, rank) {
      var key = buildClickKey(pid, rank);
      if (!key || key === '|') return false;
      var now = Date.now();
      if (key === lastClickKey && (now - lastClickAt) < CLICK_DEDUPE_MS) {
        return true;
      }
      lastClickKey = key;
      lastClickAt = now;
      return false;
    }

    function installClickPatch() {
      if (!window.Unbxd || window.Unbxd.__clickOncePatched) return !!window.Unbxd;
      window.Unbxd.__clickOncePatched = true;

      if (typeof window.Unbxd.addClick === 'function') {
        var originalAddClick = window.Unbxd.addClick.bind(window.Unbxd);
        window.Unbxd.addClick = function (pid, prank) {
          if (shouldSkipDuplicateClick(pid, prank)) return;
          return originalAddClick.apply(window.Unbxd, arguments);
        };
      }

      if (typeof window.Unbxd.track === 'function') {
        var originalTrack = window.Unbxd.track.bind(window.Unbxd);
        window.Unbxd.track = function (action, payload) {
          if (action === 'click' && payload) {
            var rank = payload.prank != null ? payload.prank : payload.pr;
            if (shouldSkipDuplicateClick(payload.pid, rank)) return;
          }
          if (action === 'search' && payload) {
            var searchQuery = payload.query || '';
            if (
              window.shouldSuppressVanillaSearchTrackForAutosuggest
              && window.shouldSuppressVanillaSearchTrackForAutosuggest(searchQuery)
            ) {
              return;
            }
          }
          if (
            (action === 'search_impression' || action === 'browse_impression')
            && payload
            && payload.pids_list
            && payload.pids_list.length
            && typeof window.Unbxd.addProductsImpression === 'function'
          ) {
            window.Unbxd.addProductsImpression(payload);
            return;
          }
          return originalTrack.apply(window.Unbxd, arguments);
        };
      }

      return true;
    }

    function waitForUnbxdClick(attempts) {
      attempts = attempts || 0;
      if (installClickPatch()) return;
      if (attempts >= 100) return;
      setTimeout(function () { waitForUnbxdClick(attempts + 1); }, 100);
    }

    waitForUnbxdClick(0);
  })();

  (function patchUnbxdCartOnce() {
    var cartLineTimers = {};
    var CART_DEBOUNCE_MS = 450;

    function buildCartLineKey(payload) {
      if (!payload) return '';
      return String(payload.pid || '') + '|' + String(payload.variantId || '');
    }

    function cloneCartPayload(payload) {
      var copy = {};
      Object.keys(payload || {}).forEach(function (key) {
        copy[key] = payload[key];
      });
      return copy;
    }

    function scheduleCartPush(originalPush, payload, meta) {
      var key = buildCartLineKey(payload);
      if (!key || key === '|') {
        originalPush('cart', payload, meta);
        return;
      }
      clearTimeout(cartLineTimers[key]);
      cartLineTimers[key] = setTimeout(function () {
        delete cartLineTimers[key];
        originalPush('cart', payload, meta);
      }, CART_DEBOUNCE_MS);
    }

    function installCartPatch() {
      if (!window.Unbxd || typeof window.Unbxd.push !== 'function') return false;
      if (window.Unbxd.__cartOncePatched) return true;
      window.Unbxd.__cartOncePatched = true;

      var originalPush = window.Unbxd.push.bind(window.Unbxd);
      window.Unbxd.push = function (action, payload, meta) {
        if (action === 'cart' && payload) {
          var snapshot = cloneCartPayload(payload);
          scheduleCartPush(function (cartAction, cartPayload, cartMeta) {
            originalPush(cartAction, cartPayload, cartMeta);
          }, snapshot, meta);
          return;
        }
        return originalPush.apply(window.Unbxd, arguments);
      };

      return true;
    }

    function waitForUnbxdCart(attempts) {
      attempts = attempts || 0;
      if (installCartPatch()) return;
      if (attempts >= 150) return;
      setTimeout(function () { waitForUnbxdCart(attempts + 1); }, 100);
    }

    waitForUnbxdCart(0);
    window.addEventListener('load', function () {
      waitForUnbxdCart(0);
    });
  })();

  window.isUnbxdQuickBuyClickTarget = function (target) {
    if (!target || typeof target.closest !== 'function') return false;
    return !!target.closest(
      'modal-opener, .quick-add__submit--, .quick-add__submit, button[name="add"][aria-haspopup="dialog"]'
    );
  };

  window.resetUnbxdFacetsSignature = function () {
    window.__unbxdLastFacetsSignature = '';
  };

  function buildUnbxdFacetsPayloadFromUrl(instance) {
    var facetsPayload = {};
    if (!instance || typeof instance.getQueryParams !== 'function') return facetsPayload;

    try {
      var params = instance.getQueryParams();
      if (!params || typeof params !== 'object') return facetsPayload;

      var facetsParam = (instance.options && instance.options.url && instance.options.url.facetsParam) || {};
      var filterReplacer = facetsParam.filterReplacer || 'filter';
      var filterValues = params[filterReplacer];
      var keyValueSep = typeof instance.getKeyValueSeparator === 'function'
        ? instance.getKeyValueSeparator()
        : '=';

      if (!filterValues && facetsParam.algo === 'KEY_VALUE_REPLACER' && typeof instance.isFilterStr === 'function') {
        var collected = [];
        Object.keys(params).forEach(function (paramKey) {
          try {
            if (instance.isFilterStr(decodeURIComponent(paramKey))) {
              collected.push(paramKey + keyValueSep + params[paramKey]);
            }
          } catch (err) {
            if (instance.isFilterStr(paramKey)) {
              collected.push(paramKey + keyValueSep + params[paramKey]);
            }
          }
        });
        filterValues = collected.length ? collected : null;
      }

      if (!filterValues) return facetsPayload;
      if (!Array.isArray(filterValues)) filterValues = [filterValues];
      if (typeof instance.getFilterFromParams !== 'function') return facetsPayload;

      var parsed = instance.getFilterFromParams(filterValues) || {};
      var selected = parsed.selectedFilters || {};

      Object.keys(selected).forEach(function (facetName) {
        var values = selected[facetName] || [];
        facetsPayload[facetName] = values.map(function (value) {
          return value && value.name != null ? value.name : value;
        });
      });

      var rangeFacet = parsed.rangeFacet || {};
      Object.keys(rangeFacet).forEach(function (facetName) {
        var rangeVal = rangeFacet[facetName] && rangeFacet[facetName][0];
        if (rangeVal) {
          facetsPayload[facetName] = rangeVal.replace(/\[|\]/g, '').split(',');
        }
      });
    } catch (err) {}

    return facetsPayload;
  }

  function buildUnbxdFacetsPayloadFromState(instance) {
    var facetsPayload = {};
    if (!instance) return facetsPayload;

    var selected = instance.getSelectedFacets ? instance.getSelectedFacets() : {};
    if (!selected || typeof selected !== 'object' || selected === -1) {
      selected = (instance.state && instance.state.selectedFacets) || {};
    }
    var rangeFacet = (instance.state && instance.state.rangeFacet) || {};
    var categoryFilter = (instance.state && instance.state.categoryFilter) || {};

    Object.keys(selected || {}).forEach(function (facetName) {
      var values = selected[facetName] || [];
      facetsPayload[facetName] = values.map(function (value) {
        return value && value.name != null ? value.name : value;
      });
    });

    Object.keys(rangeFacet || {}).forEach(function (facetName) {
      var rangeVal = rangeFacet[facetName] && rangeFacet[facetName][0];
      if (rangeVal) {
        facetsPayload[facetName] = rangeVal.replace(/\[|\]/g, '').split(',');
      }
    });

    Object.keys(categoryFilter || {}).forEach(function (facetName) {
      facetsPayload[facetName] = categoryFilter[facetName].join('>');
    });

    return facetsPayload;
  }

  function buildUnbxdFacetsPayloadFromInstance(instance) {
    var facetsPayload = buildUnbxdFacetsPayloadFromState(instance);

    if (!Object.keys(facetsPayload).length) {
      facetsPayload = buildUnbxdFacetsPayloadFromUrl(instance);
    }

    return facetsPayload;
  }

  window.unbxdUrlHasFacetFilters = function (instance) {
    try {
      var search = window.location.search || '';
      if (/[?&]filter(?:=|%3D)/i.test(search)) return true;

      if (instance && typeof instance.getQueryParams === 'function') {
        var params = instance.getQueryParams();
        var facetsParam = (instance.options && instance.options.url && instance.options.url.facetsParam) || {};
        var filterReplacer = facetsParam.filterReplacer || 'filter';
        if (params && params[filterReplacer]) return true;

        if (facetsParam.algo === 'KEY_VALUE_REPLACER' && typeof instance.isFilterStr === 'function') {
          return Object.keys(params || {}).some(function (paramKey) {
            try {
              return instance.isFilterStr(decodeURIComponent(paramKey));
            } catch (err) {
              return instance.isFilterStr(paramKey);
            }
          });
        }
      }
    } catch (err) {}
    return false;
  };

  window.hasUnbxdAppliedFacets = function (instance) {
    var payload = buildUnbxdFacetsPayloadFromInstance(instance);
    return Object.keys(payload).length > 0;
  };

  window.hasUnbxdAppliedFacetsInState = function (instance) {
    var payload = buildUnbxdFacetsPayloadFromState(instance);
    return Object.keys(payload).length > 0;
  };

  window.getUnbxdSearchQueryFromInstance = function (instance) {
    var query = '';
    if (!instance) return query;
    if (instance.state && instance.state.userInput) {
      query = String(instance.state.userInput).trim();
    }
    if (!query && typeof instance.getSearchQuery === 'function') {
      query = String(instance.getSearchQuery() || '').trim();
    }
    if (!query) {
      query = window.getUnbxdSearchQueryFromUrl ? window.getUnbxdSearchQueryFromUrl() : '';
    }
    return query;
  };

  window.getUnbxdFacetPranks = function (facetName, triggerEl, dataId) {
    var facetPrank = '';
    var valuePrank = '';
    var facetsWrapper = document.getElementById('facetsWrapper');
    if (!facetsWrapper || !facetName) {
      return { facetPrank: facetPrank, valuePrank: valuePrank };
    }

    var facetBlocks = facetsWrapper.querySelectorAll('.facets__filters, .UNX-text-facet-wrap, .UNX-facet-item-d');
    for (var i = 0; i < facetBlocks.length; i++) {
      if (
        facetBlocks[i].id === facetName ||
        facetBlocks[i].querySelector('[data-facet-name="' + facetName + '"]')
      ) {
        facetPrank = String(i + 1);
        break;
      }
    }

    var facetRoot = facetsWrapper.querySelector('[id="' + facetName.replace(/"/g, '\\"') + '"]');
    if (facetRoot) {
      var values = facetRoot.querySelectorAll(
        'li[data-search-facet-value], .UNX-facets-item, label[data-facet-name="' + facetName + '"]'
      );
      for (var j = 0; j < values.length; j++) {
        var el = values[j];
        var elId = el.getAttribute('data-search-facet-value') ||
          el.getAttribute('data-id') ||
          (el.querySelector('input') && el.querySelector('input').getAttribute('data-id'));
        if (triggerEl && (el === triggerEl || el.contains(triggerEl) || triggerEl.contains(el))) {
          valuePrank = String(j + 1);
          break;
        }
        if (dataId && String(elId) === String(dataId)) {
          valuePrank = String(j + 1);
          break;
        }
      }
    }

    return { facetPrank: facetPrank, valuePrank: valuePrank };
  };

  window.captureUnbxdFacetInteraction = function (instance, evt) {
    if (!instance || !evt) return;
    var target = evt.target;
    if (!target || typeof target.closest !== 'function') return;

    var trigger = target.closest('[data-facet-name][data-facet-action]') ||
      target.closest('.UNX-delete-facet[data-facet-action]') ||
      target.closest('.UNX-remove-facet[data-facet-action]') ||
      target.closest('[data-facet-action="clearAllFacets"]');
    if (!trigger) return;

    var facetName = trigger.getAttribute('data-facet-name') || '';
    var facetAction = trigger.getAttribute('data-facet-action') || '';

    if (facetAction === 'clearAllFacets') {
      instance.__unbxdLastFacetInteraction = {
        facetName: '',
        facetAction: facetAction,
        val: '',
        dataId: '',
        facetPrank: '',
        valuePrank: '',
        type: 'clearAll'
      };
      return;
    }
    var dataId = trigger.getAttribute('data-id') || '';
    var input = trigger.querySelector('input[type="checkbox"]');
    if (!dataId && input) {
      dataId = input.getAttribute('data-id') || '';
    }

    var val = trigger.getAttribute('data-search-facet-label') ||
      (input && input.value) ||
      trigger.getAttribute('data-facet-value') ||
      '';

    if (!val || /^x$/i.test(String(val).trim())) {
      var selectedWrap = trigger.closest('.UNX-selected-facets-wrap');
      if (selectedWrap) {
        var facetTextEl = selectedWrap.querySelector('.UNX-facet-text');
        if (facetTextEl) {
          val = facetTextEl.textContent.replace(/\(\s*\d+\s*\)/g, '').trim();
        }
      }
    }

    if ((!val || /^x$/i.test(String(val).trim())) && facetName && instance.getSelectedFacets) {
      try {
        var selectedFacets = instance.getSelectedFacets();
        var facetValues = selectedFacets && selectedFacets[facetName];
        if (facetValues && facetValues.length) {
          var matchedValue = null;
          for (var i = 0; i < facetValues.length; i++) {
            if (dataId && String(facetValues[i].dataId) === String(dataId)) {
              matchedValue = facetValues[i];
              break;
            }
          }
          if (!matchedValue) matchedValue = facetValues[0];
          if (matchedValue && matchedValue.name != null) {
            val = matchedValue.name;
          }
        }
      } catch (err) {}
    }

    if (!val) {
      val = dataId || (trigger.textContent || '').replace(/×|x|\(\d+\)/gi, '').trim();
    }

    var pranks = window.getUnbxdFacetPranks(facetName, trigger, dataId);
    var type = 'unknown';
    var deselectActions = {
      deleteFacetValue: true,
      deleteSelectedFacetValue: true,
      deleteFacet: true,
      deleteSelectedRange: true,
      clearCategoryFilter: true,
      clearPriceRange: true,
      clearRangeFacets: true
    };
    var selectActions = {
      changeFacet: true,
      setCategoryFilter: true,
      applyFacets: true
    };

    if (facetAction === 'clearAllFacets') {
      type = 'clearAll';
    } else if (deselectActions[facetAction]) {
      type = 'deselect';
    } else if (selectActions[facetAction]) {
      type = 'select';
    }

    instance.__unbxdLastFacetInteraction = {
      facetName: facetName,
      facetAction: facetAction,
      val: val,
      dataId: dataId,
      facetPrank: pranks.facetPrank,
      valuePrank: pranks.valuePrank,
      type: type
    };
  };

  function buildUnbxdPulseFacetsPayload(instance, options) {
    options = options || {};

    if (options.cleared) {
      return { unxFacetsReset: true };
    }

    var interaction = instance && instance.__unbxdLastFacetInteraction;

    if (options.deselect && interaction && interaction.type === 'deselect' && interaction.facetName) {
      var deselectedVal = { val: interaction.val };
      if (interaction.valuePrank) {
        deselectedVal.prank = String(interaction.valuePrank);
      }
      var deselectedFacet = { deselected: [deselectedVal] };
      if (interaction.facetPrank) {
        deselectedFacet.prank = String(interaction.facetPrank);
      }
      var deselectedPayload = {};
      deselectedPayload[interaction.facetName] = deselectedFacet;
      return deselectedPayload;
    }

    if (options.select && interaction && interaction.type === 'select' && interaction.facetName) {
      var selectedVal = { val: interaction.val };
      if (interaction.valuePrank) {
        selectedVal.prank = String(interaction.valuePrank);
      }
      var selectedFacet = { selected: [selectedVal] };
      if (interaction.facetPrank) {
        selectedFacet.prank = String(interaction.facetPrank);
      }
      var selectedPayload = {};
      selectedPayload[interaction.facetName] = selectedFacet;
      return selectedPayload;
    }

    return buildUnbxdFacetsPayloadFromInstance(instance);
  }

  window.trackUnbxdFacetsFromInstance = function (instance, options) {
    if (!instance || !instance.options || !instance.options.unbxdAnalytics) return;
    options = options || {};

    window.whenUnbxdTrackReady(function () {
      var facetsPayload;
      if (options.cleared) {
        facetsPayload = buildUnbxdPulseFacetsPayload(instance, { cleared: true });
      } else if (options.deselect) {
        facetsPayload = buildUnbxdPulseFacetsPayload(instance, { deselect: true });
      } else if (options.select) {
        facetsPayload = buildUnbxdPulseFacetsPayload(instance, { select: true });
      } else {
        facetsPayload = buildUnbxdFacetsPayloadFromInstance(instance);
      }

      if (!options.cleared && !Object.keys(facetsPayload).length) return;

      var productType = instance.options.productType;
      var signature = '';
      var trackPayload = { facets: facetsPayload };
      var queryContext = {};

      if (productType === 'SEARCH') {
        trackPayload.query = window.getUnbxdSearchQueryFromInstance(instance);
        queryContext.query = trackPayload.query;
        signature = 'search|' + trackPayload.query + '|' + JSON.stringify(facetsPayload);
      } else if (productType === 'CATEGORY' || productType === 'BROWSE') {
        var conf = window.UnbxdAnalyticsConf || {};
        trackPayload.page = conf.page || '';
        trackPayload.page_type = conf.page_type || '';
        signature = 'browse|' + trackPayload.page + '|' + trackPayload.page_type + '|' + JSON.stringify(facetsPayload);
      } else {
        return;
      }

      if (signature && signature === window.__unbxdLastFacetsSignature) return;
      window.__unbxdLastFacetsSignature = signature;

      if (typeof window.Unbxd.addFacets === 'function') {
        if (queryContext.query) {
          window.Unbxd.addFacets({ query: queryContext.query }, facetsPayload);
        } else {
          window.Unbxd.addFacets({
            page: trackPayload.page,
            page_type: trackPayload.page_type
          }, facetsPayload);
        }
      } else {
        window.Unbxd.track('facets', trackPayload);
      }
    });
  };

  function scheduleUnbxdFacetsTrack(instance, options) {
    if (!instance) return;
    options = options || {};
    var delay = options.delay != null ? options.delay : 120;

    clearTimeout(instance.__unbxdFacetsTrackTimer);
    instance.__unbxdFacetsTrackTimer = setTimeout(function () {
      window.trackUnbxdFacetsFromInstance(instance, options);
    }, delay);
  }

  window.scheduleUnbxdFacetsTrack = scheduleUnbxdFacetsTrack;

  window.onUnbxdAfterApiCallFacetsTrack = function (instance) {
    if (!instance) return;

    var lastAction = instance.viewState && instance.viewState.lastAction;

    if (
      lastAction === 'clearAllFacets' &&
      window.hasUnbxdAppliedFacetsInState &&
      !window.hasUnbxdAppliedFacetsInState(instance)
    ) {
      window.scheduleUnbxdFacetsTrack(instance, { delay: 200, cleared: true });
      return;
    }

    var hasFacets = window.hasUnbxdAppliedFacets && window.hasUnbxdAppliedFacets(instance);
    var urlHasFilters = window.unbxdUrlHasFacetFilters && window.unbxdUrlHasFacetFilters(instance);

    if (!hasFacets && !urlHasFilters) return;

    var delay = urlHasFilters ? 300 : 150;
    window.scheduleUnbxdFacetsTrack(instance, { delay: delay });
  };

  function patchUnbxdFacetClickHandler() {
    if (typeof window.UnbxdSearch === 'undefined') return false;
    if (window.UnbxdSearch.prototype.__unbxdFacetClickPatched) return true;
    window.UnbxdSearch.prototype.__unbxdFacetClickPatched = true;

    var originalFindChangedFacet = window.UnbxdSearch.prototype.findChangedFacet;
    window.UnbxdSearch.prototype.findChangedFacet = function (evt) {
      var target = evt && evt.target;
      if (target && typeof target.closest === 'function') {
        var facetTrigger = target.closest('[data-facet-name][data-facet-action]');
        if (facetTrigger && facetTrigger !== target) {
          evt = {
            target: facetTrigger,
            preventDefault: function () {
              if (evt.preventDefault) evt.preventDefault();
            },
            stopPropagation: function () {
              if (evt.stopPropagation) evt.stopPropagation();
            }
          };
        }
      }

      if (window.captureUnbxdFacetInteraction) {
        window.captureUnbxdFacetInteraction(this, evt);
      }

      var result = originalFindChangedFacet.call(this, evt);

      if (window.scheduleUnbxdFacetsTrack) {
        var interaction = this.__unbxdLastFacetInteraction || {};
        var isDeleteTrigger = target && typeof target.closest === 'function' && !!target.closest(
          '.UNX-delete-facet, .UNX-remove-facet, [data-facet-action="deleteSelectedFacetValue"], [data-facet-action="deleteFacetValue"]'
        );
        if (interaction.type === 'clearAll') {
          window.scheduleUnbxdFacetsTrack(this, { delay: 300, cleared: true });
        } else if (interaction.type === 'deselect' || isDeleteTrigger) {
          window.scheduleUnbxdFacetsTrack(this, { delay: 200, deselect: true });
        } else if (interaction.type === 'select') {
          window.scheduleUnbxdFacetsTrack(this, { delay: 200, select: true });
        }
      }
      return result;
    };
    return true;
  }

  function waitForUnbxdSearchFacetPatch(attempts) {
    attempts = attempts || 0;
    if (patchUnbxdFacetClickHandler()) return;
    if (attempts >= 100) return;
    setTimeout(function () {
      waitForUnbxdSearchFacetPatch(attempts + 1);
    }, 100);
  }

  waitForUnbxdSearchFacetPatch(0);

  document.addEventListener('click', function (evt) {
    var clearBtn = evt.target && evt.target.closest
      ? evt.target.closest('[data-facet-action="clearAllFacets"]')
      : null;
    if (!clearBtn) return;

    var instance = window.unbxdSearch || window.unbxdCategory;
    if (!instance || !window.scheduleUnbxdFacetsTrack) return;

    window.scheduleUnbxdFacetsTrack(instance, { delay: 350, cleared: true });
  }, true);

  document.addEventListener('click', function (evt) {
    var deleteBtn = evt.target && evt.target.closest
      ? evt.target.closest(
        '.UNX-delete-facet[data-facet-action], .UNX-remove-facet[data-facet-action], [data-facet-action="deleteSelectedFacetValue"], [data-facet-action="deleteFacetValue"]'
      )
      : null;
    if (!deleteBtn) return;

    var instance = window.unbxdSearch || window.unbxdCategory;
    if (!instance || !window.captureUnbxdFacetInteraction || !window.scheduleUnbxdFacetsTrack) return;

    window.captureUnbxdFacetInteraction(instance, evt);
    window.scheduleUnbxdFacetsTrack(instance, { delay: 250, deselect: true });
  }, true);
